export default __webpack_public_path__ + "static/char-s-13-kr-d09832019a7642704cf05afb93224bf8.webp";